import script from "./ModuleToggleSwitch.vue?vue&type=script&setup=true&lang=js"
export * from "./ModuleToggleSwitch.vue?vue&type=script&setup=true&lang=js"

import "./ModuleToggleSwitch.vue?vue&type=style&index=0&id=6db654dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6db654dc"]])

export default __exports__